import { KeyboardEvent } from 'react';
import { keyboardButtons } from './constants/keyboard-buttons';

export const submitByKeyboard = (event: KeyboardEvent<HTMLElement>) => {
  switch (event.code) {
    case keyboardButtons.ENTER:
    case keyboardButtons.SPACE:
      return true;
    default:
      return false;
  }
};

export const isTabEvent = (event: KeyboardEvent<HTMLElement>) =>
  event.code === keyboardButtons.TAB;
